import { Spacer, Text, WarningIcon } from '@sparemin/blockhead';
import React from 'react';
import { block } from './utils';

export type TextOverlayDynamicTextNotAvailableProps = {};

const TextOverlayDynamicTextNotAvailable: React.FC<TextOverlayDynamicTextNotAvailableProps> = () => {
  return (
    <Spacer
      space="16px"
      orientation="horizontal"
      align="flex-start"
      justify="flex-start"
      className={block('text-not-available')}
    >
      <WarningIcon color="#F9EB69" width={20} height={20} />

      <Text variant="label" size="14px" weight="400" lineHeight="1.4">
        Dynamic text not available for this clip.
      </Text>
    </Spacer>
  );
};

export default TextOverlayDynamicTextNotAvailable;
